module.exports = __webpack_public_path__ + "img/heart-octagon.fc04b937.svg";